import React from "react";
import { Button, InputFileTemplate } from "UiKit";
import { useNeuralInterfaceContext } from "../../NeuralInterfaceContext";
function NeuralInterfaceNavigationActions({ className }) {
    const { activeInput, toggleInputMode, stopVoiceRecording, checkVoiceRecord, addFile } = useNeuralInterfaceContext();
    return (React.createElement("div", { className: className }, activeInput === "Input" ? (React.createElement(React.Fragment, null,
        React.createElement(Button, { iconOnly: true, styleType: "text", size: "36", onClick: toggleInputMode },
            React.createElement("i", { className: "icon-microphone" })),
        React.createElement(InputFileTemplate, { renderComponent: ({ startAddFile }) => (React.createElement(Button, { iconOnly: true, styleType: "text", size: "36", onClick: startAddFile },
                React.createElement("i", { className: "icon-paper-clip" }))), onFileChange: addFile }))) : (React.createElement(React.Fragment, null,
        React.createElement(Button, { iconOnly: true, styleType: "text", size: "36", onClick: stopVoiceRecording },
            React.createElement("i", { className: "icon-x" })),
        React.createElement(Button, { iconOnly: true, styleType: "filled", size: "36", onClick: checkVoiceRecord },
            React.createElement("i", { className: "icon-check" }))))));
}
export default NeuralInterfaceNavigationActions;
